/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Row_NotionInputs */

const en_mk_calc_row_notion = /** @type {(inputs: Mk_Calc_Row_NotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notion Business`)
};

const id_mk_calc_row_notion = /** @type {(inputs: Mk_Calc_Row_NotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notion Business`)
};

/**
* | output |
* | --- |
* | "Notion Business" |
*
* @param {Mk_Calc_Row_NotionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_row_notion = /** @type {((inputs?: Mk_Calc_Row_NotionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Row_NotionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_row_notion(inputs)
	return en_mk_calc_row_notion(inputs)
});